/**
 *
 * @module entry
 * @desc {SDK.Services.Subscription} entry point.
 *
 */

import SubscriptionStatus from './subscriptionStatus';
import SubscriptionClient from './subscriptionClient';
import SubscriptionExpiryType from './subscriptionExpiryType';
import SubscriptionSourceSubType from './subscriptionSourceSubType';
import SubscriptionSourceType from './subscriptionSourceType';
import SubscriptionClientEndpoint from './subscriptionClientEndpoint';
import SubscriptionStatusSubType from './subscriptionStatusSubType';
import SubscriptionStatusType from './subscriptionStatusType';
import SubscriptionType from './subscriptionType';
import ProductRule from './productRule';

/**
 *
 * @typedef SDK.Services.Subscription
 * @type {Object}
 *
 * @property {SubscriptionStatus} SubscriptionStatus
 * @property {SubscriptionClient} SubscriptionClient
 * @property {SubscriptionExpiryType} SubscriptionExpiryType
 * @property {SubscriptionSourceSubType} SubscriptionSourceSubType
 * @property {SubscriptionSourceType} SubscriptionSourceType
 * @property {SubscriptionClientEndpoint} SubscriptionClientEndpoint
 * @property {SubscriptionStatusSubType} SubscriptionStatusSubType
 * @property {SubscriptionStatusType} SubscriptionStatusType
 * @property {SubscriptionType} SubscriptionType
 * @property {ProductRule} ProductRule
 *
 */

/**
 *
 * @type {SDK.Services.Subscription}
 *
 */
export default {

    SubscriptionStatus,
    SubscriptionClient,
    SubscriptionExpiryType,
    SubscriptionSourceSubType,
    SubscriptionSourceType,
    SubscriptionClientEndpoint,
    SubscriptionStatusSubType,
    SubscriptionStatusType,
    SubscriptionType,
    ProductRule

};



// WEBPACK FOOTER //
// ./src/services/subscription/entry.js